import React, { Component } from "react";
import {
  DarkToken,
  LightToken,
  HighlightToken
} from "../CatalogSpecimenPreview";

import "./ReactSpecimenExample.css";

class ReactSpecimenExample extends Component {
  constructor(props) {
    super(props);
    this.state = { counter: 0 };
    this.onClick = () => {
      this.setState({ counter: this.state.counter + 1 });
    };
  }
  render() {
    const { counter } = this.state;

    return (
      <button className="react-specimen-example" onClick={this.onClick}>
        Clicked
        {" "}
        <span className="react-specimen-example-counter">{counter}</span>
        {" "}
        times
      </button>
    );
  }
}

export default ReactSpecimenExample;

export const reactSpecimenExampleSource = [
  [<DarkToken>{"```react"}</DarkToken>],
  [<LightToken>{"<button "}</LightToken>],
  [
    <HighlightToken>
      {"  onClick={setState({count: state.count + 1})}"}
    </HighlightToken>,
    <LightToken>{">"}</LightToken>
  ],
  [<DarkToken>{"  Clicked {state.count} times"}</DarkToken>],
  [<LightToken>{"</button>"}</LightToken>],
  [<DarkToken>{"```"}</DarkToken>]
];



// WEBPACK FOOTER //
// ./src/components/specimen-examples/ReactSpecimenExample.js